import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Gift } from "lucide-react";

export const RewardsSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/rewards/mine").then((r) => setData(r.data)).catch(() => setData({ rewards: [] }));
  }, []);

  if (!data) return null;
  const rewards = data.rewards || [];

  return (
    <div className="mt-6 rounded-xl border border-[#FF9F0A]/30 bg-[#FF9F0A]/[0.04] p-5" data-testid="rewards-section">
      <div className="flex items-center gap-2">
        <Gift className="h-4 w-4 text-[#FF9F0A]" />
        <span className="font-bold">Share rewards</span>
      </div>
      <p className="mt-1.5 text-xs text-neutral-400">
        Share any product with the "Share this product" link — when a friend buys through it, you earn a
        discount code (up to ${(data.reward_usd ?? 0.5).toFixed(2)} off) applied at checkout.
      </p>
      {rewards.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {rewards.map((r) => (
            <span
              key={r.code}
              data-testid="reward-code-chip"
              className={`px-3 py-1.5 rounded-full text-xs font-mono border ${
                r.status === "active"
                  ? "text-[#FF9F0A] border-[#FF9F0A]/40 bg-[#FF9F0A]/10"
                  : "text-neutral-600 border-white/10 line-through"
              }`}
              title={r.status === "active" ? `Expires ${new Date(r.expires_at).toLocaleDateString()}` : r.status}
            >
              {r.code} · ${r.amount_usd.toFixed(2)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
